import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { PageOne, PageTwo, PageThree, PageFour } from './components';
;
export const DocumentTwo = memo(({ pharmacy, traderInfo, user, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(PageOne, { pharmacy: pharmacy, traderInfo: traderInfo, user: user }), _jsx(PageTwo, { pharmacy: pharmacy, traderInfo: traderInfo }), _jsx(PageThree, {}), _jsx(PageFour, { traderInfo: traderInfo })] }));
});
